import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  useQuery,
  useManualQuery,
  useMutation,
  ClientContext,
} from "graphql-hooks";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Grid,
  Paper,
  List,
  Checkbox,
  IconButton,
  Card,
  CardContent,
  Box,
  Divider,
  TextField,
  Tooltip,
  makeStyles,
} from "@material-ui/core";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { Tabs, Tab } from "@mui/material";
import { Link } from "@mui/material";
import styled from "styled-components";
import Autocomplete from "@mui/material/Autocomplete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";
import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";
import AssignedTeamDialog from "./AssignedTeamDialog.js";
import EditTeamGoalDialog from "./EditTeamGoalDialog.js";
import { project_url } from "../../constants/Data";

const StyledTooltip = styled((props) => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -45px, 20px, -35px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    paddingBottom: 16,
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  section: {
    padding: "20px",
  },
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "120px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "120px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#0D47A1",
    },
  },
  checkbox: {
    padding: "0px",
    margin: "10px 10px",
  },
  arrowButton: {
    margin: "0 10px",
    "&:hover": {
      backgroundColor: "#1E88E5",
      color: "#fff",
      border: "none",
    },
  },
  card: {
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    paddingTop: "20px",
    minHeight: "500px",
    borderRadius: "8px",
  },
  cardContent: {
    padding: "0px",
  },
  teamTabs: {
    borderBottom: "1px solid #ddd",
    paddingLeft: 50,
    paddingRight: 50,
    "& .MuiSvgIcon-root": {
      fontSize: "30px",
      "&:hover": {
        backgroundColor: "#1E88E5",
        color: "#fff",
        border: "none",
        borderRadius: "100%",
      },
    },
  },
  tabs: {
    color: "#000000de",
    "&.Mui-selected": {
      color: "#0D47A1",
      backgroundColor: "rgba(0, 0, 0, 0.1)",
    },
  },
  resourceTabs: {
  //  color: "#000000de",  
    "&.Mui-selected": {
      color: "#0D47A1",
      backgroundColor: "#E2F2FF",
    },
  },
  tab: { fontWeight: 600 },
  autoComStyle: {
    paddingRight: 16,
    "& .MuiAutocomplete-inputRoot": {
      borderRadius: 10,
    },
  },
  teamGoalTextStyle: {
    cursor: "pointer",
    fontWeight: 500,
    borderRadius: "8px",
    height: 30,
    fontSize: 14,
    display: "flex",
    padding: 5,
    paddingRight: 10,
    alignItems: "center",
    textAlign: "left",
    lineHeight: 1.2,
    wordBreak: "break-word",
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
  teamGoalTextBoxStyle: {
    height: 50,
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "center",
    paddingRight: 10,
    minWidth: 200,
  },
  teamGoalLabelTextStyle: {
    fontWeight: 500,
    borderRadius: "8px",
    height: 30,
    fontSize: 16,
    fontWeight: 600,
    display: "flex",
    padding: 5,
    // paddingRight: 10,
    alignItems: "center",
    textAlign: "left",
    minWidth: 85,
  },
}));

const membersInitialData = [
  {
    memberId: 1,
    name: "David Johnson",
    numOfTrm: "new",
    selected: false,
    role: null,
  },
  {
    memberId: 2,
    name: "Susan Sanders",
    numOfTrm: "1",
    selected: false,
    role: null,
  },
  {
    memberId: 3,
    name: "Mary Smith",
    numOfTrm: "5R",
    selected: false,
    role: null,
  },
  {
    memberId: 4,
    name: "Don Song",
    numOfTrm: "20",
    selected: false,
    role: null,
  },
  {
    memberId: 5,
    name: "Joseph Foo",
    numOfTrm: "101",
    selected: false,
    role: null,
  },
  {
    memberId: 6,
    name: "Fred Booster",
    numOfTrm: "9",
    selected: false,
    role: null,
  },
  {
    memberId: 7,
    name: "Mona Norris",
    numOfTrm: "6",
    selected: false,
    role: null,
  },
  {
    memberId: 8,
    name: "Hank Kuller",
    numOfTrm: "21",
    selected: false,
    role: null,
  },
  {
    memberId: 9,
    name: "Henry Wrinkle",
    numOfTrm: "3",
    selected: false,
    role: null,
  },
];
const staffInitialData = [
  { staffId: 1, name: "Hooshyar", numOfTrm: "21", selected: false, role: null },
  { staffId: 2, name: "Sandy", numOfTrm: "16", selected: false, role: null },
  { staffId: 3, name: "David", numOfTrm: "8", selected: false, role: null },
  { staffId: 4, name: "Rose", numOfTrm: "12", selected: false, role: null },
  { staffId: 5, name: "Robinia", numOfTrm: "6", selected: false, role: null },
];
const teamTabData = [
  { id: 1, name: "DD Team" },
  { id: 2, name: "SS Team" },
  { id: 3, name: "GMA Team" },
  { id: 4, name: "Grant Team" },
  { id: 5, name: "RR Team" },
  { id: 6, name: "FF Team" },
  { id: 7, name: "EE Team" },
];

const memberAssinedTeam = [
  {
    memberId: 1,
    name: "David Johnson",
    assignedTeam: [],
  },
  {
    memberId: 2,
    name: "Susan Sanders",
    assignedTeam: [],
  },
  {
    memberId: 3,
    name: "Mary Smith",
    assignedTeam: [
      { teamName: "DD Team", role: "Product Owner" },
      { teamName: "Grant Team", role: "Product Owner" },
    ],
  },
  {
    memberId: 4,
    name: "Don Song",
    assignedTeam: [],
  },
  {
    memberId: 5,
    name: "Joseph Foo",
    assignedTeam: [
      { teamName: "GMA Team", role: "Product Owner" },
      { teamName: "Grant Team", role: "Scrum Master" },
      { teamName: "EE Team", role: "Scrum Master" },
    ],
  },
  {
    memberId: 6,
    name: "Fred Booster",
    assignedTeam: [],
  },
  {
    memberId: 7,
    name: "Mona Norris",
    assignedTeam: [],
  },
  {
    memberId: 8,
    name: "Hank Kuller",
    assignedTeam: [
      { teamName: "DD Team", role: "Scrum Master" },
      { teamName: "Grant Team", role: "Scrum Master" },
    ],
  },
  {
    memberId: 9,
    name: "Henry Wrinkle",
    assignedTeam: [],
  },
];

const staffAssinedTeam = [
  {
    staffId: 1,
    name: "Hooshyar",
    assignedTeam: [
      { teamName: "DD Team", role: "Product Owner" },
      { teamName: "Grant Team", role: "Product Owner" },
    ],
  },
  {
    staffId: 2,
    name: "Sandy",
    assignedTeam: [
      { teamName: "SS Team", role: "Developer" },
      { teamName: "RR Team", role: "Developer" },
    ],
  },
  {
    staffId: 3,
    name: "David",
    assignedTeam: [
      { teamName: "SS Team", role: "Developer" },
      { teamName: "RR Team", role: "Developer" },
    ],
  },
  {
    staffId: 4,
    name: "Rose",
    assignedTeam: [],
  },
  {
    staffId: 5,
    name: "Robinia",
    assignedTeam: [],
  },
];
const roleData = ["Scrum Master", "Product Owner", "Developer"];

const TeamsAssignment = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const [selectedTeamTab, setSelectedTeamTab] = useState(0);
  const [selectedTab, setSelectedTab] = useState("members");
  const [alertMsg, setAlertMsg] = useState([]);
  const [openListOfTeamDlg, setOpenListOfTeamDlg] = useState(null);
  const [saveToTermDone, setSaveToTermDone] = useState(false);

  const [teamGoal, setTeamGoal] = useState("Team Goal");
  const [openEditTeamGoalDialog, setOpenEditTeamGoalDialog] = useState(false);

  const [membersData, setMembersData] = useState(membersInitialData);
  const [staffData, setStaffData] = useState(staffInitialData);

  const [clrResourceFlag, setClrResourceFlag] = useState(false);

  const [pathname] = useState(window.location.pathname);
  const [membersErrors, setMembersErrors] = useState({});
  const [staffErrors, setStaffErrors] = useState({});
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: (err) => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem(
        "refreshToken",
        refreshData.refreshToken.refreshToken
      );
      client.setHeader(
        "Authorization",
        `JWT ${refreshData.refreshToken.token}`
      );
      setLoadContent(true);
    }
  };

  const handleTeamTabChange = (event, newValue) => {
    setTeamGoal("Team Goal");
    const areMembersDataEqual =
      JSON.stringify(membersInitialData) === JSON.stringify(membersData);
    const areStaffDataEqual =
      JSON.stringify(staffInitialData) === JSON.stringify(staffData);

    if (!saveToTermDone && (!areMembersDataEqual || !areStaffDataEqual)) {
      setAlertMsg({
        title: "Teams Assignment",
        type: "copyConfirmation",
        msg:
          "Are you sure you want to leave resource assignment to team “" +
          teamTabData[selectedTeamTab].name +
          "” without saving?",
        newValue: newValue,
      });
    } else {
      setMembersData(membersInitialData);
      setStaffData(staffInitialData);
      setSelectedTab("members");
      setSelectedTeamTab(newValue);
      setSaveToTermDone(false);
      setClrResourceFlag(false);
    }
  };

  const handleListTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleDoneEditTeamGoal = (teamGoal) => {
    setTeamGoal(teamGoal);
  };

  const handleSaveToTerm = () => {
    // You can get team data info by: teamTabData[selectedTeamTab].id
    // Save to term
    if (
      !membersData.filter((item) => item.selected).length &&
      !staffData.filter((item) => item.selected).length
    ) {
      setAlertMsg({
        title: "Save To Term",
        msg:
          "You must assign resources to team “" +
          teamTabData[selectedTeamTab].name +
          "” before you can assign it to the term.",
      });
      return;
    }

    const newMembersErrors = {};
    membersData.forEach((member) => {
      if (member.selected && member.role === null) {
        newMembersErrors[member.memberId] = `You must select a role.`;
      } else delete newMembersErrors[member.memberId];
    });
    setMembersErrors(newMembersErrors);

    const newStaffErrors = {};
    staffData.forEach((staff) => {
      if (staff.selected && staff.role === null) {
        newStaffErrors[staff.staffId] = `You must select a role.`;
      } else delete newStaffErrors[staff.staffId];
    });
    setStaffErrors(newStaffErrors);
    if (
      Object.keys(newMembersErrors).length === 0 &&
      Object.keys(newStaffErrors).length === 0
    ) {
      setAlertMsg({
        title: "Team Assignment",
        msg: "Resources are successfully assigned to the team “" +
          teamTabData[selectedTeamTab].name + "”.",
      });
      setSaveToTermDone(true);
    }
  };

  const toggleClearResources = () => {
    if (!clrResourceFlag){
      setMembersData(
        membersData.map(item => 
          ({ ...item, selected: false })
        )
      );
      setStaffData(
        staffData.map(item => 
          ({ ...item, selected: false })
        )
      );
    }
    else
    {
      setMembersData(membersInitialData);
      setStaffData(staffInitialData);
    }    
    setClrResourceFlag(!clrResourceFlag);
  }

  // const handleCancelSaveToTerm = () => {
  //   setAlertMsg({
  //     title: "Teams Assignment",
  //     type: "copyConfirmation",
  //     msg:
  //       "Are you sure you want to clear resources for team “" +
  //       teamTabData[selectedTeamTab].name +
  //       "” ?",
  //     newValue: null,
  //   });
  // };

  const handleCheckboxChange = (item) => {
    if (selectedTab === "members")
      setMembersData(
        membersData.map((dataItem) =>
          dataItem.memberId === item.memberId
            ? {
                ...dataItem,
                selected: !dataItem.selected,
                role: dataItem.selected ? null : dataItem.role,
              }
            : dataItem
        )
      );
    else
      setStaffData(
        staffData.map((dataItem) =>
          dataItem.staffId === item.staffId
            ? {
                ...dataItem,
                selected: !dataItem.selected,
                role: dataItem.selected ? null : dataItem.role,
              }
            : dataItem
        )
      );
  };

  const handlePrevTeamTab = () => {
    return;
    handleChangePrevNextTeamTab(Math.max(selectedTeamTab - 1, 0));
  };

  const handleNextTeamTab = () => {
    return;
    handleChangePrevNextTeamTab(
      Math.min(selectedTeamTab + 1, teamTabData.length - 1)
    );
  };

  const handleChangePrevNextTeamTab = (newValue) => {
    if (!saveToTermDone) {
      setAlertMsg({
        title: "Teams Assignment",
        type: "copyConfirmation",
        msg:
          "Are you sure you want to leave the team assignment for “" +
          teamTabData[selectedTeamTab].name +
          "” without saving?",
        newValue: newValue,
      });
    } else {
      setMembersData(membersInitialData);
      setStaffData(staffInitialData);
      setSelectedTab("members");
      setSelectedTeamTab(newValue);
      setSaveToTermDone(false);
    }
  };

  const handleChangeRole = (item, newValue) => {
    if (item.hasOwnProperty("memberId")) {
      if (membersErrors[item.memberId] && newValue !== null)
        delete membersErrors[item.memberId];
      setMembersData(
        membersData.map((dataItem) =>
          dataItem.memberId === item.memberId
            ? { ...dataItem, role: newValue }
            : dataItem
        )
      );
    } else {
      if (staffErrors[item.staffId] && newValue !== null)
        delete staffErrors[item.staffId];
      setStaffData(
        staffData.map((dataItem) =>
          dataItem.staffId === item.staffId
            ? { ...dataItem, role: newValue }
            : dataItem
        )
      );
    }
  };
  const handleOpenListOfTeam = (item) => {
    if (selectedTab === "members")
      setOpenListOfTeamDlg(
        memberAssinedTeam.find((member) => member.memberId === item.memberId)
      );
    else
      setOpenListOfTeamDlg(
        staffAssinedTeam.find((staff) => staff.staffId === item.staffId)
      );
  };
  const members = membersData.filter((item) => item.selected);
  const staff = staffData.filter((item) => item.selected);

  const selectedTabData = selectedTab === "members" ? membersData : staffData;
  if (loadContent)
    return (
      <div className={classes.root}>
        <Header
          breadcrumbs={[
            { label: "Term Name" /*Term Name > Teams Assignment*/, link: null },
          ]}
        />
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography variant="body1" style={{ marginBottom: 10 }}>
              Teams Assignment for Sprint: Term Name{" "}
              {/* should replace with term name from DB */}
            </Typography>
          </Box>
          <Divider />

          <Box mt={3} mb={3}>
            <Grid container spacing={3}>
              <Grid item md={3}>
                <Card
                  className={classes.card}
                  style={{
                    paddingTop: 0,
                    minHeight: "725px",
                    maxHeight: "725px",
                    overflowY: "auto",
                    backgroundColor: "#E2F2FF",
                  }}
                >
                  <CardContent className={classes.cardContent}>
                    <Tabs
                      value={selectedTab}
                      onChange={handleListTabChange}
                      centered
                      style={{ paddingBottom: "10px" }}
                      sx={{
                        "& .MuiTabs-indicator": {
                          display: "none",
                        },
                      }}
                    >
                      <Tab
                        className={classes.resourceTabs}
                        sx={{
                          borderRadius: "4px",
                          paddingTop: "10px",
                          fontSize: "16px",
                          fontWeight: 600,
                          minWidth: "160px",
                          backgroundColor: "#fff",
                        }}
                        label="Members"
                        value="members"
                      />
                      <Tab
                        className={classes.resourceTabs}
                        sx={{
                          borderRadius: "4px",
                          fontSize: "16px",
                          fontWeight: 600,
                          minWidth: "165px",
                          backgroundColor: "#fff",
                        }}
                        label="Staff"
                        value="staff"
                      />
                    </Tabs>
                    <List>
                      {selectedTabData.map((item) => (
                        <ListItem key={item.name} button>
                          <Checkbox
                            className={classes.checkbox}
                            checked={item.selected}
                            onChange={() => handleCheckboxChange(item)}
                          />
                          <StyledTooltip title= {
                            selectedTab === "members" 
                            ? "View teams for this member"
                            : "View teams for this staff"}
                           >
                            <Link
                              component="button"
                              variant="body2"
                              onClick={() => handleOpenListOfTeam(item)}
                              style={{ textDecoration: "none" }}
                            >
                              <ListItemText
                                primaryTypographyProps={{ fontSize: 16 }}
                                primary={item.name + " (" + item.numOfTrm + ")"}
                              />
                            </Link>
                          </StyledTooltip>
                        </ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>
              </Grid>
              <Grid
                item
                md={9}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Card className={classes.card}>
                  <CardContent className={classes.cardContent}>
                    <Grid container alignItems="center">
                      <Grid item xs={12}>
                        <Tabs
                          value={selectedTeamTab}
                          onChange={handleTeamTabChange}
                          variant="scrollable"
                          scrollButtons="auto"
                          className={classes.teamTabs}
                        >
                          {teamTabData.map((item, index) => (
                            <Tab
                              className={classes.tabs}
                              sx={{
                                borderRadius: "4px",
                                fontSize: "16px",
                                fontWeight: 600,
                                minWidth: "160px",
                              }}
                              key={item.id}
                              label={item.name}
                            />
                          ))}
                        </Tabs>
                      </Grid>
                    </Grid>
                  </CardContent>
                  <Typography
                    variant="h3"
                    style={{ fontSize: 16, paddingTop: 10 }}
                  >
                    <b>Team Name:</b>&nbsp;{teamTabData[selectedTeamTab].name}
                  </Typography>
                  <Box pl={3}>
                    <Box className={classes.teamGoalTextBoxStyle}>
                      <Typography
                        variant="h1"
                        className={classes.teamGoalLabelTextStyle}
                      >
                        Team Goal:
                      </Typography>
                      <StyledTooltip title="Edit Team Goal">
                        <Typography
                          variant="h1"
                          className={classes.teamGoalTextStyle}
                          onClick={() => {
                            setOpenEditTeamGoalDialog(true);
                          }}
                        >
                          {teamGoal}
                        </Typography>
                      </StyledTooltip>
                    </Box>
                  </Box>
                  <Box>
                    <Button
                      variant="text"
                      color="primary"
                      className={classes.outlinedButtonStyle}
                      style={{ width: "145px" }}
                      disabled={
                        (!clrResourceFlag && 
                          !members.length && 
                          !staff.length
                        )
                      }
                      // onClick={handleCancelSaveToTerm}
                      onClick={toggleClearResources}                      
                    >
                      {clrResourceFlag
                        ? "Recall Resources"
                        : "Clear Resources"
                      } 
                    </Button>
                  </Box>
                  <Grid
                    container
                    spacing={3}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      padding: "24px",
                      paddingTop: "4px",
                    }}
                  >
                    <Grid item md={6}>
                      <Card
                        className={classes.card}
                        style={{
                          maxHeight: "500px",
                          overflowY: "auto",
                        }}
                      >
                        <Typography variant="h2" style={{ fontSize: 16 }}>
                          Members
                        </Typography>
                        <List>
                          {members.map((item) => (
                            <>
                              <Grid container alignItems="center">
                                <Grid item xs={6}>
                                  <ListItem key={item.name}>
                                    <ListItemText
                                      primaryTypographyProps={{ fontSize: 16 }}
                                      primary={item.name}
                                    />
                                  </ListItem>
                                </Grid>
                                <Grid item xs={6}>
                                  <Autocomplete
                                    className={classes.autoComStyle}
                                    key={item.memberId}
                                    value={item.role}
                                    onChange={(event, newValue) => {
                                      handleChangeRole(item, newValue);
                                    }}
                                    options={roleData}
                                    getOptionLabel={(option) => option}
                                    renderInput={(params) => (
                                      <TextField
                                        label="Role"
                                        margin="normal"
                                        name="role"
                                        variant="outlined"
                                        {...params}
                                        id="template"
                                        InputProps={{
                                          ...params.InputProps,
                                          style: { fontSize: 16 },
                                        }}
                                        InputLabelProps={{
                                          style: { fontSize: 16 },
                                        }}
                                        FormHelperTextProps={{
                                          style: {
                                            color: membersErrors[item.memberId]
                                              ? "red"
                                              : "transparent",
                                          },
                                        }}
                                        helperText={
                                          membersErrors[item.memberId]
                                        }
                                      />
                                    )}
                                  />
                                </Grid>
                              </Grid>
                            </>
                          ))}
                        </List>
                      </Card>
                    </Grid>

                    <Grid item md={6}>
                      <Card
                        className={classes.card}
                        style={{
                          maxHeight: "500px",
                          overflowY: "auto",
                        }}
                      >
                        <Typography variant="h2" style={{ fontSize: 16 }}>
                          Staff
                        </Typography>
                        <List>
                          {staff.map((item) => (
                            <>
                              <Grid container alignItems="center">
                                <Grid item xs={6}>
                                  <ListItem key={item.name}>
                                    <ListItemText
                                      primaryTypographyProps={{ fontSize: 16 }}
                                      primary={item.name}
                                    />
                                  </ListItem>
                                </Grid>
                                <Grid item xs={6}>
                                  <Autocomplete
                                    className={classes.autoComStyle}
                                    key={item.staffId}
                                    value={item.role}
                                    onChange={(event, newValue) => {
                                      handleChangeRole(item, newValue);
                                    }}
                                    options={roleData}
                                    getOptionLabel={(option) => option}
                                    renderInput={(params) => (
                                      <TextField
                                        label="Role"
                                        margin="normal"
                                        name="role"
                                        variant="outlined"
                                        {...params}
                                        id="template"
                                        InputProps={{
                                          ...params.InputProps,
                                          style: { fontSize: 16 },
                                        }}
                                        InputLabelProps={{
                                          style: { fontSize: 16 },
                                        }}
                                        FormHelperTextProps={{
                                          style: {
                                            color: staffErrors[item.staffId]
                                              ? "red"
                                              : "transparent",
                                          },
                                        }}
                                        helperText={staffErrors[item.staffId]}
                                      />
                                    )}
                                  />
                                </Grid>
                              </Grid>
                            </>
                          ))}
                        </List>
                      </Card>
                    </Grid>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.buttonStyle}
                      style={{ marginRight: 12 }}
                      onClick={handleSaveToTerm}
                    >
                      Save to Team
                    </Button>
                    <Button
                      variant="text"
                      color="primary"
                      className={classes.outlinedButtonStyle}
                      style={{ width: "135px" }}
                      onClick={() => navigate(`${project_url}/terms`)}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </Box>

          <Grid item xs={12}>
            <Grid container justifyContent="center"></Grid>
          </Grid>
          {alertMsg.msg && alertMsg.type && (
            <AlertDialog
              title={alertMsg.title}
              type={alertMsg.type}
              contentMsg={alertMsg.msg}
              closeDialog={() => {
                setAlertMsg([]);
              }}
              copyAction={() => {
                setMembersData(membersInitialData);
                setStaffData(staffInitialData);
                setSelectedTab("members");
                setClrResourceFlag(false);
                alertMsg.newValue !== null &&
                  setSelectedTeamTab(alertMsg.newValue);
                setAlertMsg([]);
              }}
            />
          )}
          {alertMsg.msg && !alertMsg.type && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => {
                setAlertMsg([]);
              }}
            />
          )}
          {openListOfTeamDlg && (
            <AssignedTeamDialog
              resourceType={selectedTab}
              resourcesTeamList={openListOfTeamDlg}
              closeDialog={() => setOpenListOfTeamDlg(null)}
            />
          )}
          {openEditTeamGoalDialog && (
            <EditTeamGoalDialog
              currentTeamTerm={teamTabData[selectedTeamTab]}
              teamGoal={teamGoal}
              closeDialog={() => {
                setOpenEditTeamGoalDialog(false);
              }}
              handleDone={(goal) => handleDoneEditTeamGoal(goal)}
            />
          )}
        </div>
      </div>
    );
};

export default TeamsAssignment;
